<template>
  <div>
    <ManageManualScoreHistoryTab />
  </div>
</template>

<script>
import ManageManualScoreHistoryTab from './components/ManageManualScoreHistoryTab.vue'

export default {
  name: 'AdminFinanceManualScoreManage',
  components: {
    ManageManualScoreHistoryTab,
  },
}
</script>
